import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { recruitingEffects } from './effects';
import { recruitingFeatureKey, reducers } from './reducers';
import { EnvironmentProviders } from '@angular/core';

export const provideRecruitingStore = (): EnvironmentProviders[] => [
    provideState(recruitingFeatureKey, reducers),
    provideEffects(recruitingEffects)
];
